<template>
    <div class="index-promo-new" id="indexPromo_carousel" v-if="indexPage != null">
        <div class="container container-promo">
            <div class="column-container">
                <div class="col-left">
                    <div class="promo-carousel">
                        <h1 v-if="indexPage.seismic_block.them_init == 'false'">{{ indexPage.enjoy_title }}</h1>
                        <router-link :to="indexPage.about_btn.link" class="link-icon" @click.native="startLoader" v-if="indexPage.seismic_block.them_init == 'false'">
                            <span>{{ indexPage.about_btn.name }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                        <swiper :options="swiperOption" ref="promoCarousel">
                            <swiper-slide v-for="(slide, index) in indexPage.corp_carousel" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                        <h2 v-if="indexPage.seismic_block.them_init == 'true'" class="seismic-title" v-html="indexPage.seismic_block.seismic_title"></h2>
                        <router-link :to="indexPage.seismic_block.seismic_btn_more.link" class="link-icon" @click.native="startLoader" v-if="indexPage.seismic_block.them_init == 'true'">
                            <span>{{ indexPage.seismic_block.seismic_btn_more.name }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                    </div>
                </div>
                <div class="col-right">
                    <div class="sales-container">
                        <div class="sales-carousel" v-if="dataArr != null && dataArr.length">
                            <swiper :options="swiperOptionSales" ref="promoSalesCarousel">
                                <swiper-slide v-for="(slide, index) in dataArr" :key="index">
                                    <!-- <div class="slide-title" v-if="slide.project_them_list != null && slide.project_them_list.length">
                                        <h3 v-html="slide.project_them_list[0].desc"></h3>
                                    </div> -->
                                    <div
                                        class="slide-title"
                                        :class="{ 'long-title': isLongTitle(slide.project_them_list[0].desc) }"
                                        v-if="slide.project_them_list != null && slide.project_them_list.length"
                                    >
                                        <h3 v-html="slide.project_them_list[0].desc"></h3>
                                    </div>
                                    <div class="slide-item">
                                        <div class="slide-info">
                                            <h4>{{ slide.project_name.name }}</h4>
                                            <p v-html="slide.project_adres"></p>
                                            <div class="project-price" v-if="slide.crm_code != null && slide.crm_code != '' && slide.project_stie_shablon_price_flats_init == 'true' && (crmProjects != null || isLdmProject(slide))">
                                                <strong :class="{'en-vers': globalLang == 'en/'}">
                                                    <span v-if="globalLang == ''">от</span><span v-if="globalLang == 'en/'">from</span>
                                                    {{ getCRMprojectInfo(slide.crm_code, 'price', slide.project_name.slug) }}
                                                    <span v-if="globalLang == ''">тг/м²</span><span v-if="globalLang == 'en/'">tg/м²</span><span v-if="globalLang == 'kz/'">тг. бас.</span>
                                                </strong>
                                            </div>
                                        </div>
                                        <div class="slide-img">
                                            <div class="slide-pic" :style="'background-image: url(' + slide.img + ')'"></div>
                                            <a :href="slide.project_site_in.link" class="link-icon" target="_blank">
                                                <svgIcon name="arrow-go-right"/>
                                            </a>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-pagination promo-sales-pagination"></div>
                        </div>
                    </div>
                    <div class="news-container">
                        <h3 class="news-title-mobile" v-if="isMobileChecker">{{ indexPage.news_title_home }}</h3>
                        <div class="news-item-promo" v-if="newsItemData != null">
                            <router-link :to="{ name: 'news-card', params: { 'id': newsItemData.slug } }">
                                <div class="news-title">
                                    <h4 v-html="newsItemData.acf.title"></h4>
                                </div>
                                <div class="news-desc">
                                    <p v-for="desc in newsItemData.acf.first_elem_default.desc_red.slice(0,1)" v-html="desc.desc"></p>
                                </div>
                                <div class="link-icon">
                                    <svgIcon name="arrow-go-right"/>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';

    const LDM_SLUGS = ['benelux', 'vesper']

    export default {
        name: 'indexPoromo',
        components: {
            svgIcon,
        },
        data() {
            return {
                iSmobile: false,
                size: 15,
                amount: 40,
                speed: 1.5,
                dataArr: null,
                newsItemData: null,
                hideControls: false,
                globalLang: window.GlobalLang,
                ldmPrices: {},
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: true,
                    },
                },
                swiperOptionSales: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    slidesPerView: 1,
                    simulateTouch: true,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: true,
                    },
                    pagination: {
                        el: '.promo-sales-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                }
            }
        },
        computed: {
            ...mapGetters({
                indexPage: 'loadIndexPage',
                flatsPage: 'loadFlatsPage',
                projectItems: 'loadProjectItems',
                projectItemsDefault: 'loadProjectItemsDefault',
                projectItemsFilter: 'loadProjectItemsFilter',
                crmProjects: 'loadCrmProjects',
                isMobileChecker: 'loadIsMobileChecker',
                setup: 'loadPageSetUp',
                // ucoCRM_authToken: 'loadUcoCRM_auth_token',
            }),
            swiper() {
                return this.$refs.promoCarousel.swiper
            }
        },
        methods: {
            // ── LDM helpers ───────────────────────────────────────────
            isLdmProject(item) {
                return LDM_SLUGS.includes(item.project_name.slug)
            },

            isLongTitle(desc) {
                if (!desc) return false
                const text = desc.replace(/<[^>]*>/g, '').trim()
                return text.length > 30
            },

            fetchLdmPrice(id, slug) {
                const complexCodes = id.split(',').map(c => c.trim())
                axios.post(window.CRMProxy + '/v1/complexes', { complexCodes }).then(({ data }) => {
                    if (data.data && data.data.length > 0) {
                        const prices = data.data
                            .map(c => c.minMeterPrice)
                            .filter(v => v !== null && v !== undefined)
                            .map(Number)
                        const min = prices.length ? Math.min(...prices) : null
                        this.$set(this.ldmPrices, slug, min ? this.getNumber(min) : null)
                    } else {
                        this.$set(this.ldmPrices, slug, null)
                    }
                }).catch(() => {
                    this.$set(this.ldmPrices, slug, null)
                })
            },

            fetchLdmPricesForItems(items) {
                if (!items || !items.length) return
                items.forEach(item => {
                    if (
                        this.isLdmProject(item) &&
                        item.crm_code &&
                        !(item.project_name.slug in this.ldmPrices)
                    ) {
                        this.fetchLdmPrice(item.crm_code, item.project_name.slug)
                    }
                })
            },

            // ── Основной метод получения цены ────────────────────────
            getCRMprojectInfo(id, key, slug) {
                // LDM проекты — берём из отдельного запроса
                if (slug && LDM_SLUGS.includes(slug)) {
                    if (key === 'price') {
                        return this.ldmPrices[slug] || false
                    }
                    return false
                }

                if (!id || !this.crmProjects) return false

                const codes = id.split(',').map(c => c.trim())
                const matches = this.crmProjects.filter(item => codes.includes(item.code))

                if (!matches.length) return false

                if (key === 'price') {
                    const prices = matches
                        .map(m => m.minMeterPrice)
                        .filter(v => v !== null && v !== undefined && v !== 0)
                        .map(Number)
                    if (!prices.length) return false
                    return this.getNumber(Math.min(...prices))
                }

                const total = matches.reduce((sum, m) => sum + (m.apartmentsQuantity || 0), 0)
                return total || false
            },

            // ── Остальные методы ──────────────────────────────────────
            filterItemsForPromo() {
                if (this.dataArr === null && this.indexPage != null && this.indexPage.small_carousel_complexes != null && this.projectItemsDefault != null) {
                    var arrItems = []
                    var filterItem
                    var data = this.indexPage.small_carousel_complexes
                    var projects = this.projectItemsDefault
                    for (var i = 0; i < data.length; i++) {
                        filterItem = projects.filter(item => {
                            return item.id == data[i].sales_post.ID
                        })
                        if (filterItem.length) {
                            arrItems.push({
                                ...filterItem[0],
                                img: data[i].img
                            })
                        }
                    }
                    this.dataArr = arrItems
                    if (this.dataArr.length <= 1) {
                        this.hideControls = true
                    }
                    // запускаем загрузку LDM цен после сборки dataArr
                    this.fetchLdmPricesForItems(this.dataArr)
                }
            },

            getNewsItem() {
                if (this.indexPage != null) {
                    const ID = this.indexPage.newsblock.ID
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news/' + ID).then(async (response) => {
                        this.newsItemData = response.data
                    })
                }
            },

            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
            },

            slideClicked(index) {
                var data = this.dataArr[index],
                    name = this.dataArr[index].project_name.slug
                if (data.project_site_type != null && data.project_site_type == 'link') {
                    window.open(data.project_site_in.link, '_blank')
                } else if (data.project_site_type != null) {
                    this.$router.push({ name: 'sales-app', params: { id: name } })
                } else {
                    return false
                }
            },

            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.size = 10
                    this.amount = 20
                    this.speed = .5
                }
            },

            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.size = 10
                    this.amount = 20
                    this.speed = .5
                } else {
                    this.iSmobile = false
                }
            },

            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize()
            },

            startLoader() {
                this.$parent.$parent.$refs.topProgress.start()
            },
        },

        mounted() {
            this.filterItemsForPromo()
            this.getNewsItem()
            this.isMobileCheck()
            this.checkResize()

            this.$store.watch(
                (state) => state.indexPage,
                (newValue) => {
                    if (newValue) {
                        this.filterItemsForPromo()
                        this.getNewsItem()
                    }
                }
            )
            this.$store.watch(
                (state) => state.projectItemsDefault,
                (newValue) => {
                    if (newValue) {
                        this.filterItemsForPromo()
                        this.getNewsItem()
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/index-promo-new.scss';
    @import '@/styles/respond/index-promo/respond-index-promo-new.scss';
</style>